<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.99997 11.414L5.70697 15.707L4.29297 14.293L8.58597 9.99997L4.29297 5.70697L5.70697 4.29297L9.99997 8.58597L14.293 4.29297L15.707 5.70697L11.414 9.99997L15.707 14.293L14.293 15.707L9.99997 11.414Z" fill="url(#paint0_linear_800_4)"/>
    <defs>
      <linearGradient id="paint0_linear_800_4" x1="16.505" y1="5.28943" x2="2.96731" y2="10.7825" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FB3B1F"/>
        <stop offset="0.454955" stop-color="#F82A3F"/>
        <stop offset="1" stop-color="#EF008A"/>
      </linearGradient>
    </defs>
  </svg>
</template>
